module.exports = __webpack_public_path__ + "img/infosec.a7e547e1.svg";